import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListAttachmentsComponent } from './list/list-attachments.component';
import { CreateAttachmentComponent } from './create/create-attachment.component';
import { AttachmentService } from './attachment.service';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { FormsModule } from '@angular/forms';
import { UploadFileModule } from '../upload-file/upload-file.module';
import { FileUploadModule } from 'ng2-file-upload';
import { EditLogoComponent } from './logo/edit-logo.component';

@NgModule({
  imports: [
    CommonModule,
    SweetAlert2Module,
    FormsModule,
    NgxSmartModalModule,
    UploadFileModule,
    FileUploadModule
  ],
  declarations: [
    ListAttachmentsComponent,
    CreateAttachmentComponent,
    EditLogoComponent
  ],
  providers: [
    AttachmentService
  ],
  exports: [
    ListAttachmentsComponent,
    CreateAttachmentComponent,
    EditLogoComponent
  ]
})
export class AttachmentsModule { }




// WEBPACK FOOTER //
// ./client/app/shared/attachments/attachments.module.ts